export interface Config {
    rentalsThinEndpoint: string;
}

export let config: Config;

export function initializeConfig() {
    config = {
        rentalsThinEndpoint: process.env.REACT_APP_RENTALS_THIN_API,
    }
}
